export const AnalyticsEventName = {
	landingCtaClicked: 'funnel_landing_cta_click',
	registrationCompleted: 'funnel_registration_complete',
	profileCompleted: 'funnel_profile_complete',
	testCompleted: 'funnel_test_complete',
	profileOpened: 'engagement_profile_opened',
	searchOpened: 'engagement_search_opened',
	searchFiltersApplied: 'engagement_search_filters_applied',
	searchFilterRemoved: 'engagement_search_filter_removed',
	searchCompatibilityToggled: 'engagement_search_compatibility_toggled',
	messageStarted: 'engagement_message_started',
	conversationOpened: 'engagement_conversation_opened',
	firstMessageSent: 'engagement_first_message_sent',
	favoriteAdded: 'engagement_favorite_added'
} as const;

export type AnalyticsEvent = (typeof AnalyticsEventName)[keyof typeof AnalyticsEventName];

export const AnalyticsStandardParam = {
	sourcePage: 'source_page',
	targetPage: 'target_page',
	ctaName: 'cta_name',
	funnelStep: 'funnel_step',
	filterCount: 'filter_count',
	compatibilityMode: 'compatibility_mode',
	filterKind: 'filter_kind',
	messageType: 'message_type',
	roomType: 'room_type',
	roomId: 'room_id'
} as const;
